import Vue from "vue";
import GlobalFooter from "./ui/GlobalFooter.vue";
import Notifications from "./ui/Notifications.vue";
export default Vue.extend({
    components: {
        GlobalFooter: GlobalFooter,
        Notifications: Notifications,
    },
});
